// Compatibility for views that still calculate over complete leave history.
// Each HTTP request stays bounded; the employee request table fetches one page.
export async function fetchLeaveRequestHistory(api, userId, params = {}) {
    const url = `/leave/requests/${userId}`;
    const limit = 100;
    const response = await api.get(url, { params: { ...params, page: 1, limit } });
    const content = response.data?.data?.content || response.data?.content;
    if (!Array.isArray(content?.data)) return response;

    const rows = [...content.data];
    for (let page = 2; rows.length < content.total; page += 1) {
        const next = await api.get(url, { params: { ...params, page, limit } });
        const batch = next.data?.data?.content?.data || next.data?.content?.data || [];
        if (!batch.length) break;
        rows.push(...batch);
    }
    content.data = rows;
    return response;
}
